import React, { useState } from "react";
import { Modal, Image, Container, Row, Col, CloseButton } from "react-bootstrap";
import femaleForm from "assets/img/illustrations/femaleForm.png";
import maleForm from "assets/img/illustrations/maleForm.png";
import formulation from "assets/img/illustrations/formulation.png";
import gstProduct from "assets/img/illustrations/product_gst.jpg";
import femaleWin from "assets/img/illustrations/female_win.png";

function AdditionImage() {
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const handleImageClick = (src) => {
    setCurrentImage(src);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentImage("");
  };

  const images = [femaleForm, maleForm, formulation, gstProduct, femaleWin];

  return (
    <Container className="d-flex gap-2 my-2">
      <Row>
        {images.map((src, index) => (
          <Col key={index} md="auto">
            <Image
              src={src}
              thumbnail
              width={200}
              onClick={() => handleImageClick(src)}
              style={{ cursor: "pointer" }}
            />
          </Col>
        ))}
      </Row>
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Body className="text-center">
          <CloseButton
            onClick={handleClose}
            className="position-absolute top-0 border text-white fw-bold end-0 m-2 bg-danger rounded-circle p-2"
          />
          <Image src={currentImage} fluid />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default AdditionImage;
